import $ from 'jquery'

const disableIneligibleWorkflows = (form) => {
  const $form = $(form)
  const accountMappingInput = $form.find(
    'div.company_template_account_mapping_list'
  )
  const defaultWorkflowSelect = $form.find(
    'select#company_template_default_firm_workflow_id'
  )
  const additionalWorkflowSelect = $form.find(
    'div[data-behaviour=company-template-firm-workflows-list] select'
  )

  const defaultWorkflowId = defaultWorkflowSelect.val()
  const personalWorkflowIds = $form
    .data('personal-workflow-ids')
    .map((e) => e.toString())
  const corporateWorkflowIds = defaultWorkflowSelect
    .children('option')
    .toArray()
    .map((e) => e.value)
    .filter((e) => !personalWorkflowIds.includes(e) && e !== '')
  const hasPersonalCompanies = $form.data('has-personal-companies')
  const hasCorporateCompanies = $form.data('has-corporate-companies')

  const enableOptions = (selectElement, optionIds) => {
    for (const id of optionIds) {
      selectElement.children(`option[value='${id}']`).attr('disabled', false)
    }
  }

  const disableOptions = (selectElement, optionIds) => {
    for (const id of optionIds) {
      selectElement
        .children(`option[value='${id}']`)
        .attr('disabled', true)
        .prop('selected', false)
    }
  }

  if (hasPersonalCompanies) {
    disableOptions(defaultWorkflowSelect, corporateWorkflowIds)
  } else if (hasCorporateCompanies) {
    disableOptions(defaultWorkflowSelect, personalWorkflowIds)
  }

  if (personalWorkflowIds.includes(defaultWorkflowId)) {
    accountMappingInput.hide()

    enableOptions(additionalWorkflowSelect, personalWorkflowIds)
    disableOptions(additionalWorkflowSelect, corporateWorkflowIds)
  } else {
    accountMappingInput.show()

    enableOptions(additionalWorkflowSelect, corporateWorkflowIds)
    disableOptions(additionalWorkflowSelect, personalWorkflowIds)
  }

  // Disable selecting the Default Workflow in Additional Workflows
  disableOptions(additionalWorkflowSelect, [defaultWorkflowId])
}

let observer = null

onDomLoad(() => {
  if (observer) {
    observer.disconnect()
  }

  document
    .querySelectorAll("[data-behaviour='client-type-form']")
    .forEach((form) => {
      disableIneligibleWorkflows(form)

      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const target = mutation.target
          if (
            target.closest(
              '[data-behaviour="company-template-firm-workflows-list"]'
            )
          ) {
            disableIneligibleWorkflows(form)
          }
        })
      })

      const workflowsList = form.querySelector(
        '[data-behaviour="company-template-firm-workflows-list"]'
      )
      if (workflowsList) {
        observer.observe(workflowsList, {
          childList: true,
          subtree: true,
        })
      }

      form
        .querySelector('#company_template_default_firm_workflow_id')
        ?.addEventListener('change', () => {
          disableIneligibleWorkflows(form)
        })
    })
})

document.addEventListener('turbolinks:before-visit', () => {
  if (observer) {
    observer.disconnect()
    observer = null
  }
})
